import React from 'react';
import { createPortal } from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import PartsModal from './PartsModal';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { Search } from 'react-bootstrap-icons';

class Material extends ChemComponent {
	constructor(props) {
		super(props);
		
		var material = {
			SHOP_ID: props.params.shopId,
			JOB_ID: null,
			PART_ID: null,
			PART_NAME: '',
			PART_NAME_UCASE: '',
			PART_QTY: '',
			PART_COST: '',
			COMMENTS: '',
			JOB_DATE: this.dateTimeToMVC(new Date()),
			ORDER_BY: ['JOB_DATE desc','UPDATE_DATE desc']
		};
		
		var materialEntryInit = this.copyColumns(materialEntry);
		materialEntryInit[0].options.search = { Attribute: 'SHOP_ID', Operator: '=', LongValue: props.params.shopId };
		materialEntryInit[1].options.search = { Attribute: 'SHOP_ID', Operator: '=', LongValue: props.params.shopId };
		
		var materialListInit = this.copyTable(materialList);
		materialListInit.query.search = this.constructSearch(material);
		materialListInit.query.order = material.ORDER_BY;

		this.state = {
			material: material,
			materialEntry: materialEntryInit,
			materialList: materialListInit,
			searchCount: null,
			showPartSearch: false,
			partSearchProps: null,
			renderKey: 0
		};
	}
	
	viewJob(jobId) {
		this.props.setJobEditable(false);
		this.props.navigate('/Jobtrack/Jobs/' + jobId);
	}

	onChangeSearch(accessor, value) {
		var material = this.copyObject(this.state.material);
		this.setByAccessor(material, accessor, value);
		if (Array.isArray(accessor) && accessor.includes('PART_NAME')) {
			for (var i = 0; i < accessor.length; i++) {
				if (accessor[i] === 'PART_NAME') {
					if (this.isEmpty(value[i])) {
						this.setByAccessor(material, 'PART_NAME_UCASE', '');
					} else {
						this.setByAccessor(material, 'PART_NAME_UCASE', '%' + value[i] + '%');
					}
					break;
				}
			}
		}
		this.mergeState({ material: material });
	}

	constructSearch(data) {
		return ({ Attribute: 'SHOP_ID', Operator: '=', LongValue: this.props.params.shopId });
	}
	
	addMaterialEntry() {
		var self = this;
		
		// send material entry to server
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/AddMaterialEntry',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				material: this.state.material
			}
		}).done(function (data) {
			if (data.Success) {		
				// update state so that unbilled material table will reload
				self.mergeState({
					searchCount: null,
					renderKey: self.state.renderKey + 1
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	onSubmitSearch(event, newOrderBy) {
		// copy material in case we need to incorporate the new ordering
		var material = this.copyObject(this.state.material);
		var newMaterialList = this.copyTable(materialList);
		newMaterialList.query.search = this.constructSearch(material);
		if (newOrderBy) {
			material.ORDER_BY = newOrderBy;
			newMaterialList.query.order = newOrderBy;
		}
		
		this.mergeState({
		    material: material,
		    materialList: newMaterialList,
		    showSearch: false,
		    searchCount: null,
		    renderKey: this.state.renderKey + 1
	    });
	}
	
    onSearchResult(data) {
        this.mergeState({
            searchCount: data.ResultCount
		});
	}
			
	renderPartSearch(props) {
	  var self = this;
	  
	  return(
		<PartsModal parent={this} user={this.props.user} onClose={(accessor, value) => {
			var newState = {
				material: self.copyObject(self.state.material)
			};
			if (accessor !== undefined && accessor !== null) {
				self.setByAccessor(newState.material, accessor, value);
			}
			newState.showPartSearch = false;
			newState.partSearchProps = null;
			self.mergeState(newState);
		}} />
	  );
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Unbilled Material',
			columns: exportColumns,
			entity: 'RECHARGES.UNBILLED_LABOR_VW',
			search: this.constructSearch(this.state.material),
			order: this.state.material.ORDER_BY
		});			
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Material Entry for Shop</div>
						<ChemEdit parent={this} user={this.props.user} columns={this.state.materialEntry} data={this.state.material}
						  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
						{this.state.showPartSearch && createPortal(this.renderPartSearch(this.state.partSearchProps), document.body)}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="update" variant="warning" type="button" className="float-end" 
						  onClick={() => this.addMaterialEntry()}>Save</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
                  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_Unbilled_Material' table={this.state.materialList}
                    order={this.state.material.ORDER_BY} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
                    onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const materialEntry = [
	{ Header: 'Job', accessor: 'JOB_ID', type: 'select', row: 0, col: 0, required: true,
		options: { value: 'JOB_ID', label: 'JOB_INFO', entity: 'RECHARGES.SHOP_JOB_SELECT_VW', order: 'JOB_ID desc' }},
	{ Header: 'Part', accessor: 'PART_ID', type: 'multicolumn', row: 0, col: 1, compare: 'indexOf', required: true,
		labelAccessor: ['PART_NAME','UNIT_OF_MEASURE','MANUF_NUM','ALT_DESC','VENDOR_PART'], 
		options: { value: 'PART_ID', entity: 'RECHARGES.JOB_PART_SELECT_VW', order: 'PART_NAME_UCASE',
			label: ['PART_NAME','UNIT_OF_MEASURE','MANUF_NUM','ALT_DESC','VENDOR_PART'],
			search: { Attribute: 'SHOP_ID', Operator: '=', LongAccessor: 'SHOP_ID' }}},
	{ Header: 'Part Search', accessor: 'PART_ID', row: 0, col: 2,
		Cell: props => <Button style={{ marginTop: '-8px' }} id="partSearch" variant="warning" type="button"
			onClick={() => props.parent.mergeState({ 
				showPartSearch: true, 
				partSearchProps: {
					accessor: props.accessor,
					value: props.value,
					onChange: (accessor, value) => props.parent.onChangeSearch(accessor, value)
				}})}><Search /></Button> },
	{ Header: 'Qty', accessor: 'PART_QTY', row: 1, col: 0, required: true },
	{ Header: 'Remarks', accessor: 'COMMENTS', type: 'textarea', row: 1, col: 1 },
	{ Header: 'Date', accessor: 'JOB_DATE', type: 'date', row: 1, col: 2, required: true }
];

const materialList = {
	query: { entity: 'RECHARGES.UNBILLED_MATERIAL_VW' },
	pageSize: 20,
	columns: [
		{ Header: '', accessor: 'JOB_ID', show: false },
		{ Header: 'Job ID / Description', accessor: 'JOB_INFO', width: 300,
			Cell: props => <HashLink onClick={() => props.parent.viewJob(props.row.values.JOB_ID)}>{props.value}</HashLink> },
		{ Header: 'Part', accessor: 'PART_NAME', width: 200 },
		{ Header: 'Qty', accessor: 'PART_QTY', width: 50 },
		{ Header: 'Unit Cost', accessor: 'UNIT_COST', width: 80 },
		{ Header: 'UOM', accessor: 'UNIT_OF_MEASURE', width: 50 },
		{ Header: 'Total Cost', accessor: 'TOTAL_COST', width: 80 },
		{ Header: 'Remarks', accessor: 'COMMENTS', width: 200 },
		{ Header: 'Trans Date', accessor: 'JOB_DATE', width: 100,
			Cell: props => props.parent.dateToString(props.value) },
		{ Header: 'Status', accessor: 'READY_TO_BILL', width: 100 },
		{ Header: 'Last Update', accessor: 'UPDATE_DATE', width: 100,
			Cell: props => props.parent.dateToString(props.value) }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'PART_ID', width: 12 },
	{ Header: 'Shop', accessor: 'SHOP_NAME', width: 20 },
	{ Header: 'Category', accessor: 'CATEGORY_NAME', width: 25 },
	{ Header: 'Part Name', accessor: 'PART_NAME', width: 60 },
	{ Header: 'Alt. Desc', accessor: 'ALT_DESC', width: 25 },
	{ Header: 'Use Unit', accessor: 'UNIT_OF_MEASURE', width: 12 },
	{ Header: 'Recharge Cost', accessor: 'UNIT_COST', width: 16 },
	{ Header: 'Vendor', accessor: 'VENDOR_NAME', width: 25 },
	{ Header: 'Vendor Part #', accessor: 'VENDOR_PART', width: 25 },
	{ Header: 'Vendor Price', accessor: 'VENDOR_PRICE', width: 15 },
	{ Header: 'Vendor Unit', accessor: 'VENDOR_UNIT', width: 15 },
	{ Header: 'Vendor Qty/Unit', accessor: 'VENDOR_UNIT_QTY', width: 15 },
	{ Header: 'Cross Reference', accessor: 'X_REF', width: 25 },
	{ Header: 'Manufacturer Number', accessor: 'MANUF_NUM', width: 25 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 80 },
	{ Header: 'Inventory', accessor: 'STOCK_QTY', width: 20 }
];

export default withRouter(Material);
